import React from "react"
import { useTranslation } from "react-i18next"

import { hasPermissions } from "apps/auth/auth"
import FeeList from "apps/fees/Fee/FeeList"
import Button from "components/Button/Button"
import Icon from "components/Icon/Icon"
import { actionsColumn } from "components/Table"
import Tooltip from "components/Tooltip/Tooltip"
import { reverse } from "utils/urls"

export default function AirlineFeeList(props) {
  const { t } = useTranslation()

  return (
    <FeeList
      tableConfig={{
        endpoint: "/fees/airline-fees",
        title: t("Airline Fees"),
        tableName: "airline-fee-table-config",
        buttons: (
          <>
            {hasPermissions(["add_fees_airlinefee"]) && (
              <Button icon="plus" to={reverse("airlineFeeCreate")}>
                {t("Add Fee")}
              </Button>
            )}
          </>
        ),
      }}
      actionsColumn={actionsColumn(obj => (
        <>
          <Tooltip title={t("Fee History")}>
            <Icon.Link
              name="history"
              color="gray"
              to={reverse("history", {
                id: obj.id,
                model: encodeURIComponent("fees/airline-fees"),
              })}
            />
          </Tooltip>
          <Tooltip title={t("Edit Fee")}>
            <Icon.Link
              name="edit"
              linkClassName="ml-3"
              to={reverse("airlineFeeUpdate", { id: obj.id })}
            />
          </Tooltip>
          <Tooltip title={t("Delete Fee")}>
            <Icon.Link
              name="remove"
              color="danger"
              linkClassName="ml-3"
              to={reverse("airlineFeeDelete", { id: obj.id })}
            />
          </Tooltip>
        </>
      ))}
    />
  )
}
